import React from 'react'
import PropTypes from 'prop-types'
import {Button, Img, Text} from '@chakra-ui/react'
import {remCalc} from '../../../../theme/_utils'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import CategoryLinkGroup from '../CategoryLinkGroup'

export const getTemplateLinks = (primarycategory) => {
    const bottomLinkEntries = Array.isArray(primarycategory?.bottom_links)
        ? primarycategory.bottom_links
        : [primarycategory?.bottom_links]
    const bottomLinks = bottomLinkEntries.flatMap((entry) => entry?.links ?? [])
    const primaryLinks = bottomLinks
        .slice(0, 3)
        .map((link) => ({...link, link: link?.redirect ?? link?.link}))
    const fallbackLinks = primarycategory?.links?.icon_and_link ?? []

    return [...primaryLinks, ...fallbackLinks.slice(0, 3 - primaryLinks.length)]
}

const hasMeaningfulValue = (value) => {
    if (typeof value === 'string') {
        return value.trim().length > 0
    }

    if (Array.isArray(value)) {
        return value.some(hasMeaningfulValue)
    }

    if (value && typeof value === 'object') {
        return Object.values(value).some(hasMeaningfulValue)
    }

    return Boolean(value)
}

export const hasValidPrimaryCard = (primarycategory) => {
    const redirect = primarycategory?.card?.redirect

    if (!redirect || typeof redirect !== 'object') {
        return false
    }

    return [redirect?.cta, redirect?.categorysfcc, redirect?.productsfcc, redirect?.psp_url].some(
        hasMeaningfulValue,
    )
}

export const IconLinkButton = ({link, categoryData, locale, styles}) => {
    const {label, url, isAbsolute} =
        getGlobalLink({
            link: link?.link,
            categoriesData: categoryData,
            locale: locale?.alias,
        }) || {}

    return (
        <Button
            variant="link-button-no-underline"
            size="base"
            leftIcon={link?.icon?.url && <Img {...styles.iconImage} src={link.icon.url} />}
            as="a"
            px={0}
            paddingY={remCalc(4)}
            href={url}
            isExternal={isAbsolute}
            maxHeight={remCalc(26)}
        >
            <Text {...styles?.iconLinkText}>{label}</Text>
        </Button>
    )
}

IconLinkButton.propTypes = {
    link: PropTypes.object,
    categoryData: PropTypes.object,
    locale: PropTypes.object,
    styles: PropTypes.object.isRequired,
}

export const CategoryGroupColumn = ({
    group,
    categoryData,
    locale,
    styles,
    isLast = false,
    ...rest
}) => (
    <CategoryLinkGroup
        group={group}
        categoryData={categoryData}
        locale={locale}
        styles={styles}
        flexDirection="column"
        alignItems="flex-start"
        gap="xxsmall.base"
        width={isLast ? '100%' : remCalc(343)}
        {...rest}
    />
)

CategoryGroupColumn.propTypes = {
    group: PropTypes.object,
    categoryData: PropTypes.object,
    locale: PropTypes.object,
    styles: PropTypes.object.isRequired,
    isLast: PropTypes.bool,
}

export const templatePropTypes = {
    primarycategory: PropTypes.object,
    categoryData: PropTypes.object,
    locale: PropTypes.object,
}
